import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	isResponsive: false,
	displaySideMenu: false,
	isDropdownOpen: false,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.UPDATE_RESPONSIVE:
			return { ...state, isResponsive: action.isResponsive };
		case ActionTypes.TOGGLE_SIDE_MENU:
			return { ...state, displaySideMenu: action.showSideMenu };
		case ActionTypes.HIDE_SIDE_MENU:
			return { ...state, displaySideMenu: false };
		case ActionTypes.SHOW_SIDE_MENU:
			return { ...state, displaySideMenu: true };
		case ActionTypes.DROPDOWN_OPEN:
			return { ...state, isDropdownOpen: true };
		case ActionTypes.DROPDOWN_CLOSE:
			return { ...state, isDropdownOpen: false };
		default:
			return state;
	}
};
